import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { adminGuard } from './guards/admin.guard';
import { clientPublicGuard } from './guards/client-panel.guard';
import { LoginSafeTraceComponent } from './pages/login-safe-trace/login-safe-trace.component';
import { PublicPanelGuard } from './guards/public.guard';
import { LoginAssaiComponent } from './pages/login-assai/login-assai.component';

export const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [ PublicPanelGuard ] },
  { path: 'login', component: LoginComponent, canActivate: [ PublicPanelGuard ] },
  { path: 'panel', loadChildren: () => import('../app/pages/panel/panel.routes').then(e => e.PANEL_ROUTES), canActivate: [authGuard], canActivateChild: [adminGuard] },
  { path: 'client-panel', loadChildren: () => import('./pages/client-panel/client-panel.routes').then(e => e.CLIENT_PANEL_ROUTES), canActivate: [authGuard, clientPublicGuard] },
  { path: 'support-panel', loadChildren: () => import('./pages/support-panel/support-panel.routes').then(e => e.SUPPORT_PANEL_ROUTES), canActivate: [authGuard] },
  { path: 'menu-system', loadChildren: () => import('./pages/menu-system/menu-system.routes').then(e => e.MENU_SYSTEM_ROUTES), canActivate: [authGuard] },
  { path: 'safetrace', component: LoginSafeTraceComponent },
  { path: 'safetrace/login', component: LoginSafeTraceComponent },
  { path: 'safetrace/login/:id', component: LoginSafeTraceComponent },
  { path: 'assai', component: LoginAssaiComponent },
  { path: 'assai/login', component: LoginAssaiComponent },
  { path: 'assai/login/:id', component: LoginAssaiComponent },
  { path: '**', redirectTo: 'panel' },
];
